import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { loginUser, setAuthError, loadAuthData, logout } from '../../store/slices/auth';

// import { ReactComponent as LoginKeyIcon } from '../../assets/images/loginKey.svg';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ReactComponent as LoginMailIcon } from '../../assets/images/loginMailIcon.svg';
import s10Logo from '../../assets/images/s10Logo.png';

import { Button, Grid, InputAdornment, Typography, Divider, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MyTextField from '../../components/MyTextField';

import validationSchema from '../../schemas/login.schema';
import { useFormik } from 'formik';
import LoadingComponent from '../../components/LoadingComponent';
import SelectCompanyModal from '../../components/SelectCompanyModal';
import MySnackbar from '../../components/MySnackbar';
import { Link } from 'react-router-dom';


const Login = () => {
  const theme = useTheme();
  const dispatch = useDispatch<AppDispatch>();
  const authState = useSelector((state: RootState) => state.auth);
  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const savedUsername = localStorage.getItem("rememberedUsername");
    if (savedUsername) {
      formik.setFieldValue("username", savedUsername);
      formik.setFieldValue("rememberMe", true);
    }
    if (authState.isLogged === false) {
      dispatch(loadAuthData());
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const loginHandler = () => {
    const { username, password, rememberMe } = formik.values;

    if (!username || !password) {
      dispatch(setAuthError("Email y password son requeridos."));
      return;
    }
    if (rememberMe) {
      localStorage.setItem("rememberedUsername", username);
    } else {
      localStorage.removeItem("rememberedUsername");
    }

    dispatch(loginUser({ UserName: username, Password: password }));
  };

  const formik = useFormik({
    initialValues: { 
      username: localStorage.getItem("rememberedUsername") || "", 
      password: "", 
      rememberMe: !!localStorage.getItem("rememberedUsername")
     },
    validationSchema,
    onSubmit: loginHandler,
  });

  if (loading) {
    return <label>Cargando...</label>;
  }

  return (
    <Grid container style={{ height: "100vh", margin: "0 !important" }}>
      <Grid
        container
        item
        xs={12}
        md={6}
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ backgroundColor: theme.s10palette.S10Blueblue50 }}
      >
        <MySnackbar
          open={authState.autherror !== ""}
          autoHideDuration={6000}
          msg={authState.autherror}
          severity="error"
          onClose={() => dispatch(setAuthError(""))}
        />
        <Grid
          container
          direction="row"
          maxWidth="20rem"
          alignItems="center"
          rowSpacing="1rem"
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Grid justifyContent="center" alignItems="center" alignContent="center" item xs={12} style={{ marginTop: ".5rem" }}>
            <img style={{ width: "8.75rem" }} src={s10Logo} alt="S10" />
          </Grid>
          <Typography variant="h3" style={{ marginBottom: "0.5rem" }}>
            ¡Bienvenido!
          </Typography>
          <Typography variant="h6">Portal del colaborador - Ingresar</Typography>
          <Divider
            style={{
              width: "100%",
              marginTop: "1.19rem",
              marginBottom: "1.5rem",
              color: theme.s10palette.S10Blueblue100,
            }}
          />
          <Typography variant="body1" align="left" width="100%">
            Ingresa tus credenciales
          </Typography>
          <MyTextField
            id="username"
            label="Usuario"
            type="text"
            name="username"
            value={formik.values.username}
            onChange={formik.handleChange}
            error={formik.values.username.length > 3 && Boolean(formik.errors.username)}
            helperText={formik.values.username.length > 3 ? formik.errors.username : ""}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ color: theme.s10palette.S10Greygrey900 }}>
                  <LoginMailIcon />
                </InputAdornment>
              ),
            }}
          />
          <Grid item >
            <MyTextField
              id="password"
              label="Contraseña"
              type={showPassword ? "text" : "password"}
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.values.password.length > 3 && Boolean(formik.errors.password)}
              helperText={formik.values.password.length > 3 ? formik.errors.password : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <FormControlLabel
            control={
              <Checkbox
                checked={formik.values.rememberMe}
                onChange={(e) => formik.setFieldValue("rememberMe", e.target.checked)}
                color="primary"
              />
            }
            label="Recordarme"
          />
          <Typography variant="body2" style={{ marginTop: '10px' }}>
            ¿Olvidaste tu contraseña?{' '}
            <Link to="/recuperar-contrasena" color="primary">
              Recupérala aquí
            </Link>
          </Typography>
          <Grid item width="20rem" style={{ marginTop: "1rem" }}>
            <Button variant="contained" type="submit" fullWidth>
              Iniciar sesión
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        md={6}
        sx={{ display: { xs: "none", md: "block" } }}
        style={{
          backgroundColor: theme.s10palette.S10Blueblue700,
          backgroundImage: `url(loginDefaultImage.svg)`,
        }}
      />
      {authState.isLoading && <LoadingComponent loadingText="Iniciando sesión..." />}
      <SelectCompanyModal
        open={authState.isLogged === true && !authState.companyselected}
        cancelAction={() => dispatch(logout())}
        errorMessage={(error) => dispatch(setAuthError(error))}
      />
    </Grid>
  );
};

export default Login;
